import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { ToastrComponentlessModule, ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/http/auth.service";
@Injectable()
export class HttpInterceptorService implements HttpInterceptor {


  public static methodsToProcess = ['GET', 'POST', 'PUT', 'DELETE'];
  public static showToastMomentaneously = true;
  public static successfulResponses = [201, 200];
  public static errorResponses = [400, 401, 403, 404, 405];
  public static serverErrorResponses = [500, 504];

  private isLoggedOut: boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthService
    ) { }
  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    const idToken = localStorage.getItem('token');

    if (idToken) {
      req = req.clone({
        headers: req.headers.set('Authorization',
          'Bearer ' + idToken)
      });
    }
    req.headers.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains')
    .set('Cache-Control', 'no-cache, no-store, must-revalidate')
    .set('Pragma', 'no-cache')
    .set('Expires', '0')
    .set('X-Frame-Options', 'DENY')
    .set('X-XSS-Protection', '1; mode=block')
    .set('X-Content-Type-Options', 'nosniff')
    .set('Set-Cookie', 'HttpOnly; Secure; SameSite=Strict')
    .set('Referrer-Policy', "no-referrer")
    .set('Content-Security-Policy', "default-src 'self'; form-action 'self'; object-src 'none'");


    return next.handle(req).pipe(tap(
      evt => {
        if (evt instanceof HttpResponse) {
        }
      }
    ),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if(err.status == 401)
            if(!this.isLoggedOut){
              this.logOut()
              this.toastr.error('Session timed out. Please log in.');
            }
        }
        return throwError(err);
      }));
  }

  logOut(){
    this.isLoggedOut = true;
    setTimeout(() =>{
      this.authService.logout()
      this.isLoggedOut = false;
    }, 1000)
   }
}
